import Link from '@zenbusiness/zui/Link';

/**
 * Appends the selected billing interval as a query param on the Squarespace
 * website CTA destination (select-plan flow). Always returns a relative URL.
 *
 * @param {string} url - Product CTA URL from useProductCtaUrl
 * @param {{ interval?: string }} [options]
 * @returns {string}
 */
export function buildStaticWebsiteSqspCtaUrl(url, { interval } = {}) {
  if (!interval || !url) {
    return url;
  }

  const parsed = new URL(url, window.location.origin);
  parsed.searchParams.set('interval', interval);
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}

/** FormattedMessage values for the Squarespace buy-box legal note. */
export const STATIC_WEBSITE_SQSP_NOTE_VALUES = {
  privacyPolicy: (chunks) => (
    <Link
      href="https://www.squarespace.com/privacy"
      size="sm"
      underline="none"
      target="_blank"
      rel="noopener noreferrer"
    >
      {chunks}
    </Link>
  ),
  termsOfService: (chunks) => (
    <Link
      href="https://www.squarespace.com/terms-of-service"
      size="sm"
      underline="none"
      target="_blank"
      rel="noopener noreferrer"
    >
      {chunks}
    </Link>
  ),
};
